import { combineReducers } from '../utils/redux';

import mapRefs from './mapRefs';
import sidebar from './sidebar';
import modal from './modal';
import snackbar from './snackbar';
import infodrawer from './infodrawer';
import mapLayers from './mapLayers';
import plan from './plan';

const reducers = combineReducers({
  sidebar,
  mapRefs,
  modal,
  snackbar,
  infodrawer,
  mapLayers,
  plan,
});

export default reducers;
